var imagesLoaded = require('imagesloaded');
if (window) {
  window.imagesLoaded = imagesLoaded;
}
require('angular');
require('./angular-images-loaded');
module.exports = 'hj.imagesLoaded';
